<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{
  img: string
  title: string
  subcontent?: string
}>()

enum ImageType {
  Collection = 'no_collection', // 无收藏
  Messages = 'no_messages', // 无消息
  Order = 'no_order', // 无订单
  ResultsFound = 'no_results_found', // 搜索无结果
  Traveler = 'no_traveler', // 未添加行程
  Login = 'no_login', // 登陆
  SubmitQuestion = 'submit_a_question', // 提交问题
  NoNetwork = 'no_network', // 无网络
}

const imageName = ref('')
imageName.value
  = (ImageType as any)[props.img] || props.img || ImageType.ResultsFound // 默认
</script>

<template>
  <div class="empty-wrap relative">
    <div class="empty flex flex-col items-center">
      <img
        class="empty-wrap-img"
        :src="
          `//file.reshg.com/hopegoo/public/empty/img_indicator_common_detail_${
            imageName
          }1.png?v=1`
        "
        alt="empty"
      >
      <p class="text-title">
        {{ title }}
      </p>
      <p class="text-info">
        {{ subcontent }}
      </p>
    </div>
  </div>
</template>

<style scoped>
.empty-wrap {
  color: black;
  text-align: center;
  &-img {
    height: 280px;
    width: 280px;
  }

  .text-title {
    margin-top: 8px;
    font-size: 16px;
    text-align: center;
    font-style: normal;
    font-weight: 600;
  }

  .text-info {
    margin-top: 8px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }

}
</style>
